export default __webpack_public_path__ + "static/media/portfoliocomline.21286e68.png";